<div *ngIf="status" class="status-badge" [class]="className">{{ status }}</div>
